import React from 'react';
import './Home.css';

import logo from '../../images/hero-image-with-logo.jpg';

class Home extends React.Component {
  render() {
    return (
      <div className="home">
          <div className="hero-image-container">
            <img className="hero-image" alt="Red Lines Band" src={logo}/>
          </div>
      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home/Home.js